import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import showformmodel from "../showformmodel/showformmodel.vue" 

export default {
    name: "studyActivityForms",
    components: {
        customModal,
        showformmodel
    },
    props: {
        soaId :{
            type: String,
            default: ""
        }
    },
    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            token: "",
            head: {},
            currentform: "",
            setshowActivityFormModal: false,
            soAItem: {},
        };
    },
    async mounted(){
        this.token = store.getters.getIdToken;
        this.head = {
            headers: {
                Authorization: "Bearer " + this.token,
                "Content-Type": "application/json",
            },
        };
        await this.getSoA(this.soaId);
    },
    methods:{
        async getSoA(soaId) {
            await axios
                .get(`${this.baseurl}/management/study/getsoa?Id=${soaId}`, this.head)
                .then((res) => {
                    this.soAItem = res.data;
                })
                .catch((err) => console.log("error creating SoA"));
        },
        closeFormModal(){
            this.$emit("closeModal");
        },
        async gotoform(formid) {
            this.currentform = formid;      
            this.setshowActivityFormModal = true;
        },
        closeformActivityModal() {
            this.currentform = "";
            this.setshowActivityFormModal = false;

        },
    }

}